/* SantApp — interacciones propias (sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sa-reveal:not(.sa-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sa-visible'); });
      return;
    }
    if (!window.__saObs) {
      window.__saObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('sa-visible');
            window.__saObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__saObs.observe(el); });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-sa-tabs]').forEach(function (wrap) {
      if (wrap.__saTabs) return;
      wrap.__saTabs = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = wrap.querySelector('#' + t.getAttribute('aria-controls'));
            if (p) p.classList.toggle('sa-activo', on);
          });
          initReveal(wrap);
        });
      });
    });
  }

  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-sa-cifra]:not([data-sa-hecho])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-sa-hecho', '1');
      var fin = parseFloat(el.getAttribute('data-sa-cifra')) || 0;
      var dec = (String(el.getAttribute('data-sa-cifra')).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toLocaleString('es-CO', { minimumFractionDigits: dec }); return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - k, 3));
        el.textContent = v.toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (k < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-sa-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        if (window.innerWidth < 990) { el.style.transform = ''; return; }
        var k = parseFloat(el.getAttribute('data-sa-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (centro * -k / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* Ofertas por cantidad: al pulsar, abre el formulario de contraentrega (allí se elige y cobra la oferta) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sa-oferta]');
    if (!btn) return;
    document.querySelectorAll('[data-sa-oferta]').forEach(function (b) { b.classList.toggle('sa-oferta--activa', b === btn); });
    var cod = Array.prototype.find.call(document.querySelectorAll('#_rsi-buy-now-button'), function (b) { return b.offsetParent !== null; });
    if (cod) cod.click();
    else {
      var add = document.querySelector('.product-form__submit');
      if (add) add.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* Portada: carrusel automático de productos (pausa al pasar el ratón o si la pestaña no está visible) */
  function initHeroCarrusel(root) {
    root.querySelectorAll('[data-sa-hero-carrusel]').forEach(function (car) {
      if (car.dataset.saListo) return;
      car.dataset.saListo = '1';
      var slides = car.querySelectorAll('.sa-hero__slide');
      var puntos = car.querySelectorAll('.sa-hero__punto');
      if (slides.length < 2) return;
      var visual = car.closest('.sa-hero__visual');
      var etiqueta = visual && visual.querySelector('[data-sa-hero-etiqueta]');
      var intervalo = parseInt(car.dataset.saHeroCarrusel, 10) || 4000;
      var actual = 0, timer = null, pausa = false;
      var quieto = false; /* el usuario quiere movimiento aunque Windows tenga "reducir animaciones" */

      function ir(i) {
        i = (i + slides.length) % slides.length;
        if (i === actual) return;
        slides[actual].classList.remove('sa-activo');
        slides[actual].setAttribute('aria-hidden', 'true');
        slides[actual].setAttribute('tabindex', '-1');
        if (puntos[actual]) puntos[actual].classList.remove('sa-activo');
        actual = i;
        var s = slides[actual];
        s.classList.add('sa-activo');
        s.removeAttribute('aria-hidden');
        s.removeAttribute('tabindex');
        if (puntos[actual]) puntos[actual].classList.add('sa-activo');
        if (etiqueta) {
          etiqueta.classList.add('sa-cambiando');
          setTimeout(function () {
            etiqueta.href = s.getAttribute('href');
            etiqueta.querySelector('[data-sa-hero-titulo]').textContent = s.dataset.titulo;
            etiqueta.querySelector('[data-sa-hero-precio]').textContent = s.dataset.precio;
            etiqueta.classList.remove('sa-cambiando');
          }, 300);
        }
      }
      function arrancar() { parar(); if (!quieto) timer = setInterval(function () { if (!pausa && !document.hidden) ir(actual + 1); }, intervalo); }
      function parar() { if (timer) clearInterval(timer); timer = null; }

      puntos.forEach(function (p) { p.addEventListener('click', function (e) { e.preventDefault(); ir(parseInt(p.dataset.i, 10)); arrancar(); }); });
      car.addEventListener('mouseenter', function () { pausa = true; });
      car.addEventListener('mouseleave', function () { pausa = false; });
      var x0 = null;
      car.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      car.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { ir(actual + (dx < 0 ? 1 : -1)); arrancar(); }
      });
      arrancar();
    });
  }

  /* Menú de escritorio: las subcategorías se abren a la derecha al pasar el ratón (y se cierra la anterior) */
  function initMenuLateral(root) {
    var escritorio = window.matchMedia('(min-width: 990px) and (hover: hover)');
    root.querySelectorAll('.header__submenu > li > details').forEach(function (det) {
      if (det.dataset.saLateral) return;
      det.dataset.saLateral = '1';
      var li = det.parentElement, t = null;
      function cerrarHermanos() {
        li.parentElement.querySelectorAll(':scope > li > details[open]').forEach(function (d) { if (d !== det) d.removeAttribute('open'); });
      }
      li.addEventListener('mouseenter', function () { if (!escritorio.matches) return; clearTimeout(t); cerrarHermanos(); det.setAttribute('open', ''); });
      li.addEventListener('mouseleave', function () { if (!escritorio.matches) return; t = setTimeout(function () { det.removeAttribute('open'); }, 180); });
      det.addEventListener('toggle', function () { if (det.open) cerrarHermanos(); });
    });
  }

  /* Página de producto: la galería pasa sola de una foto a otra cada 4 s.
     Se detiene al pasar el ratón, mientras la galería no se ve en pantalla, con la ampliación abierta
     y durante 12 s después de que el cliente toque o elija una foto. Aplica a todos los productos. */
  function initGaleriaAuto(root) {
    root.querySelectorAll('media-gallery').forEach(function (gal) {
      if (gal.dataset.saAuto) return;
      if (typeof gal.setActiveMedia !== 'function') {
        if (gal.dataset.saEspera) return;
        gal.dataset.saEspera = '1';
        if (window.customElements) customElements.whenDefined('media-gallery').then(function () { initGaleriaAuto(gal.parentElement); });
        return;
      }
      gal.dataset.saAuto = '1';
      var thumbs = gal.querySelector('[id^="GalleryThumbnails"]');
      if (!thumbs) return;
      var items = Array.prototype.slice.call(thumbs.querySelectorAll('[data-target]'));
      if (items.length < 2) return;
      var INTERVALO = 4000, ESPERA = 12000;
      var encima = false, hastaTs = 0;

      function actual() {
        var b = thumbs.querySelector('button[aria-current="true"]');
        var li = b && b.closest('[data-target]');
        var i = items.indexOf(li);
        return i < 0 ? 0 : i;
      }
      function puede() {
        if (encima || document.hidden || Date.now() < hastaTs) return false;
        if (document.querySelector('product-modal[open]')) return false;
        /* solo si la parte de arriba de la galería está a la vista (así nunca mueve la página) */
        var r = gal.getBoundingClientRect();
        return r.height > 0 && r.top >= 0 && r.top < window.innerHeight * 0.6;
      }
      setInterval(function () {
        if (!puede()) return;
        gal.setActiveMedia(items[(actual() + 1) % items.length].dataset.target, false);
      }, INTERVALO);

      function esperar() { hastaTs = Date.now() + ESPERA; }
      gal.addEventListener('mouseenter', function () { encima = true; });
      gal.addEventListener('mouseleave', function () { encima = false; });
      gal.addEventListener('click', esperar, true);
      gal.addEventListener('touchstart', esperar, { passive: true, capture: true });
      gal.addEventListener('keydown', esperar, true);
    });
  }

  function initAll(root) {
    initGaleriaAuto(root);
    initMenuLateral(root);
    initReveal(root);
    initTabs(root);
    initCifras(root);
    initHeroCarrusel(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initParallax();
  });

  /* Editor de Shopify: reinicia al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.matches && e.target.matches('[role="tab"]') ? e.target : null;
    var panel = e.target.closest && e.target.closest('.sa-panel');
    if (panel) {
      var t = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (t) t.click();
    } else if (tab) tab.click();
  });
})();
